// After a sales panel closes, the view behind it re-renders (the by-video list even
// refetches), so the element that opened the panel may not exist yet. Focus it as soon
// as it appears: the VideosTable sales button, else the "Analytics by video" row.
// Never steals focus the user already moved somewhere else; gives up after timeoutMs.
// Returns a cleanup function.
const targetsFor = (videoId) => [`sales-video-${videoId}`, `by-video-row-${videoId}`];

const findTarget = (videoId) => {
  const wanted = targetsFor(videoId);
  // Compare attributes instead of building a selector from a URL-provided id.
  const nodes = Array.from(document.querySelectorAll('[data-testid]'));
  for (const id of wanted) {
    const match = nodes.find((n) => n.getAttribute('data-testid') === id);
    if (match) return match;
  }
  return null;
};

const focusIsFree = () => !document.activeElement || document.activeElement === document.body;

export default function restoreFocusToSalesEntry(videoId, { timeoutMs = 3000 } = {}) {
  const tryFocus = () => {
    if (!focusIsFree()) return true; // user moved on: stop trying
    const target = findTarget(videoId);
    if (target) target.focus();
    return !!target;
  };
  if (tryFocus()) return () => {};

  let timer = null;
  const observer = new MutationObserver(() => { if (tryFocus()) stop(); });
  function stop() {
    observer.disconnect();
    clearTimeout(timer);
  }
  observer.observe(document.body, { childList: true, subtree: true });
  timer = setTimeout(stop, timeoutMs);
  return stop;
}
